/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Draft_Published_ToastInputs */

const en_us2_draft_published_toast = /** @type {(inputs: Draft_Published_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`New plan in effect`)
};

const pt_br2_draft_published_toast = /** @type {(inputs: Draft_Published_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Novo plano ativo`)
};

const es_419_draft_published_toast = /** @type {(inputs: Draft_Published_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nuevo plan activo`)
};

const pt_pt2_draft_published_toast = /** @type {(inputs: Draft_Published_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Novo plano ativo`)
};

const fr_fr2_draft_published_toast = /** @type {(inputs: Draft_Published_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nouveau programme actif`)
};

const de_de2_draft_published_toast = /** @type {(inputs: Draft_Published_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Neuer Plan aktiv`)
};

const it_it2_draft_published_toast = /** @type {(inputs: Draft_Published_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nuova scheda attiva`)
};

/**
* | output |
* | --- |
* | "New plan in effect" |
*
* @param {Draft_Published_ToastInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const draft_published_toast = /** @type {((inputs?: Draft_Published_ToastInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Draft_Published_ToastInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_draft_published_toast(inputs)
	if (locale === "es-419") return es_419_draft_published_toast(inputs)
	if (locale === "pt-PT") return pt_pt2_draft_published_toast(inputs)
	if (locale === "fr-FR") return fr_fr2_draft_published_toast(inputs)
	if (locale === "de-DE") return de_de2_draft_published_toast(inputs)
	if (locale === "it-IT") return it_it2_draft_published_toast(inputs)
	return en_us2_draft_published_toast(inputs)
});
export { draft_published_toast as "draft.published_toast" }